import styled from 'styled-components';

const StyledMedicalLeaveFormReason = styled.div`
   width: 100%;
   max-width: 600px;
`;
StyledMedicalLeaveFormReason.displayName = 'StyledMedicalLeaveFormReason';

export { StyledMedicalLeaveFormReason };
